import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import debounce from 'lodash/debounce';
import Sliders from '@deliveroo/icon-set/react/Sliders';
import Icon from '@deliveroo/consumer-component-library/components/Icon';
import Spacer from '@deliveroo/consumer-component-library/components/Spacer';
import UnstyledButton from '@deliveroo/consumer-component-library/components/UnstyledButton';

import isHomeSearchActive from '../../utils/home/isHomeSearchActive';

import { showLocationSearchModal } from '../../actions/locationActions';
import {
  requestHomeFeed,
  toggleLogisticsModal as toggleLogisticsModalAction,
} from '../../actions/homeFeedActions';

import { isFeatureActive } from '../../selectors/configSelectors';
import {
  buildSelectedFilters,
  buildDefaultFilters,
  getDateTimeLabel,
  getUrl,
  getCollectionLink,
  getTitle,
  getNeighborhood,
  getSearchId,
  getHasMultipleFulfillmentMethods,
  showLogisticsModal as showLogisticsModalSelector,
  getFulfillmentMethod,
} from '../../selectors/homeSelectors';

import { getIsHomeMapOpen } from '../../selectors/homeMapSelectors';

import { setParams } from '../../utils/home/filters';
import {
  trackTappedFilterIcon,
  trackTappedFilterOption,
  trackTappedFilter,
  trackToggleFilterSection,
  trackViewedMobileFiltersHomeFeed,
  trackTappedLogisticsControl as trackTappedLogisticsControlAction,
} from '../../actions/tracking/filters';

import SidebarFiltersHome from '../../components/SidebarFiltersHome';
import HomeFiltersLogisticsControl from '../../components/HomeFiltersLogisticsControl';
import HomeFiltersFulfillmentControlMobile from '../HomeFiltersFulfillmentControlMobile';
import HomeFiltersModal from '../../components/HomeFiltersModal';
import HomeTitle from '../../components/HomeTitle';
import HomeSearchContainer from '../HomeSearchContainer';

import { CO_CLICK_AND_COLLECT } from '../../flags/features';

import { fulfillmentMethodType } from '../HomeFiltersFulfillmentControl/proptypes';

import styles from './styles.scss';

// eslint-disable-next-line react/no-deprecated
export class HomeFeedFilters extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedFilters: props.selectedFilters,
      isFilterModalOpen: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.loading) {
      window.scrollTo(0, 0);
    }

    if (!nextProps.loading && nextProps.searchId !== this.props.searchId) {
      if (nextProps.webUrl) {
        window.history.replaceState(null, null, `${nextProps.webUrl}`);
      }

      this.setState({ selectedFilters: nextProps.selectedFilters });
    }

    if (!nextProps.loading && nextProps.error) {
      this.setState({ selectedFilters: nextProps.selectedFilters });
    }
  }

  onFilterModalToggle = () => {
    if (!this.state.isFilterModalOpen) {
      this.props.trackTappedFilterIcon();
    }

    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      isFilterModalOpen: !this.state.isFilterModalOpen,
    });
  };

  handleEditLocation = (e) => {
    e.preventDefault();
    this.props.showLocationSearchModal();
  };

  setSelectedFilters = (filterOption, filter) => {
    this.props.trackTappedFilterOption({ filterOption, filter, selected: !filterOption.selected });

    const { selectedFilters } = this.state;

    if (this.props.loading) return;

    this.setState(
      {
        selectedFilters: setParams({ type: filter.optionsType, filterOption, selectedFilters }),
      },
      () => {
        this.props.applyFilters(this.state.selectedFilters);
      },
    );
  };

  handleFilterAndSortChange = (selectedFilters) => {
    this.setState({ selectedFilters }, () => {
      this.props.applyFilters(this.state.selectedFilters);
    });
  };

  handleExitCollection = () => {
    this.props.onExitCollection();
  };

  renderHomeTitleAndFilters = () => {
    const { title, titleLink, loading, isSearchEnabled } = this.props;
    return (
      <div className={styles.filtersWithHeader}>
        <HomeTitle
          title={title}
          titleLink={titleLink}
          onClick={this.handleExitCollection}
          isPlaceholder={loading}
        />
        {!isSearchEnabled && (
          <a
            onClick={this.onFilterModalToggle}
            href="#filters-modal"
            className={styles.filtersLink}
          >
            <Icon component={Sliders} size={18} color="teal" />
          </a>
        )}
      </div>
    );
  };

  // MVT-1139 layout
  renderSearchAndFilters() {
    return (
      <div className={styles.searchAndFilters}>
        <div className={styles.stretch}>
          <HomeSearchContainer isMobile />
        </div>
        <a onClick={this.onFilterModalToggle} href="#filters-modal" className={styles.filtersLink}>
          <Icon component={Sliders} size={18} color="teal" />
        </a>
      </div>
    );
  }

  renderLogisticsAndFilters() {
    const {
      dateTimeLabel,
      neighborhood,
      showFulfillmentSwitchControl,
      isSearchEnabled,
      showLogisticsModal,
      toggleLogisticsModal,
      trackTappedLogisticsControl,
      withClickAndCollect,
      selectedMethod,
    } = this.props;

    return (
      <Spacer spacing="large 0 0 0">
        <div className={styles.logisticsFilters}>
          <HomeFiltersLogisticsControl
            compact
            dateTimeLabel={dateTimeLabel}
            neighborhood={neighborhood}
            showLogisticsModal={showLogisticsModal}
            toggleLogisticsModal={toggleLogisticsModal}
            trackTappedLogisticsControl={trackTappedLogisticsControl}
            selectedMethod={selectedMethod}
            withClickAndCollect={withClickAndCollect}
          />
          {!isSearchEnabled && (
            <Spacer spacing="0 0 0 small">
              <UnstyledButton onClick={this.onFilterModalToggle}>
                <span className={styles.filtersButton}>
                  <Icon component={Sliders} size={18} color="teal" />
                </span>
              </UnstyledButton>
            </Spacer>
          )}
        </div>
        {withClickAndCollect &&
          showFulfillmentSwitchControl && (
            <Spacer spacing="medium 0 0 0">
              <HomeFiltersFulfillmentControlMobile />
            </Spacer>
          )}
      </Spacer>
    );
  }

  render() {
    const {
      titleLink,
      filters,
      sort,
      neighborhood,
      dateTimeLabel,
      loading,
      trackTappedFilter: localTrackTappedFilter,
      trackTappedFilterOption: localTrackTappedFilterOption,
      trackToggleFilterSection: localTrackToggleFilterSection,
      trackViewedMobileFilters,
      defaultFilters,
      isHomeMapOpen,
      isSearchEnabled,
      withClickAndCollect,
      showFulfillmentSwitchControl,
      showLogisticsModal,
      toggleLogisticsModal,
      trackTappedLogisticsControl,
      selectedMethod,
    } = this.props;

    const isCollection = !!titleLink;
    const combinedFilters = [...sort, ...filters];

    return (
      <div className={styles.wrapper}>
        <div className={styles.desktopFilters}>
          <SidebarFiltersHome
            filters={combinedFilters}
            selectedFilters={this.state.selectedFilters}
            setSelectedFilters={this.setSelectedFilters}
            isPlaceholder={loading}
            neighborhood={neighborhood}
            dateTimeLabel={dateTimeLabel}
            trackToggleFilterSection={localTrackToggleFilterSection}
            withClickAndCollect={withClickAndCollect}
            showFulfillmentSwitchControl={showFulfillmentSwitchControl && !isHomeMapOpen}
            showLogisticsModal={showLogisticsModal}
            toggleLogisticsModal={toggleLogisticsModal}
            trackTappedLogisticsControl={trackTappedLogisticsControl}
            selectedMethod={selectedMethod}
          />
        </div>

        <div className={styles.mobileFilters}>
          {!isCollection && this.renderLogisticsAndFilters()}
          {isSearchEnabled && this.renderSearchAndFilters()}
          {isCollection && this.renderHomeTitleAndFilters()}
          <HomeFiltersModal
            appElement="#__next"
            isOpen={this.state.isFilterModalOpen}
            onChange={this.handleFilterAndSortChange}
            onClose={this.onFilterModalToggle}
            filters={combinedFilters}
            selectedFilters={this.state.selectedFilters}
            defaultFilters={defaultFilters}
            trackTappedFilter={localTrackTappedFilter}
            trackTappedFilterOption={localTrackTappedFilterOption}
            trackViewedMobileFilters={trackViewedMobileFilters}
          />
        </div>
      </div>
    );
  }
}

HomeFeedFilters.propTypes = {
  title: PropTypes.string,
  titleLink: PropTypes.string,
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      header: PropTypes.string.isRequired,
      images: PropTypes.shape({
        icon: PropTypes.shape({
          name: PropTypes.string,
          image: PropTypes.string,
        }),
      }).isRequired,
      options: PropTypes.arrayOf(
        PropTypes.shape({
          count: PropTypes.number,
          name: PropTypes.string.isRequired,
          selected: PropTypes.bool,
          id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        }).isRequired,
      ).isRequired,
      styling: PropTypes.shape({
        mobile: PropTypes.shape({
          collapse: PropTypes.string,
          seperators: PropTypes.string,
        }),
        desktop: PropTypes.shape({
          collapse: PropTypes.string,
          seperators: PropTypes.string,
        }),
      }),
      optionsType: PropTypes.string.isRequired,
      text: PropTypes.string,
    }),
  ).isRequired,
  sort: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      header: PropTypes.string.isRequired,
      images: PropTypes.shape({
        icon: PropTypes.shape({
          name: PropTypes.string,
          image: PropTypes.string,
        }),
      }).isRequired,
      options: PropTypes.arrayOf(
        PropTypes.shape({
          count: PropTypes.number,
          name: PropTypes.string.isRequired,
          selected: PropTypes.bool,
          id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        }).isRequired,
      ).isRequired,
      styling: PropTypes.shape({
        mobile: PropTypes.shape({
          collapse: PropTypes.string,
          seperators: PropTypes.string,
        }),
        desktop: PropTypes.shape({
          collapse: PropTypes.string,
          seperators: PropTypes.string,
        }),
      }),
      optionsType: PropTypes.string.isRequired,
      text: PropTypes.string,
    }),
  ).isRequired,
  selectedFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  defaultFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  loading: PropTypes.bool.isRequired,
  neighborhood: PropTypes.string,
  showLocationSearchModal: PropTypes.func.isRequired,
  toggleLogisticsModal: PropTypes.func.isRequired,
  trackTappedLogisticsControl: PropTypes.func.isRequired,
  applyFilters: PropTypes.func.isRequired,
  dateTimeLabel: PropTypes.string,
  searchId: PropTypes.string,
  trackTappedFilter: PropTypes.func.isRequired,
  trackTappedFilterOption: PropTypes.func.isRequired,
  trackTappedFilterIcon: PropTypes.func.isRequired,
  trackToggleFilterSection: PropTypes.func.isRequired,
  trackViewedMobileFilters: PropTypes.func.isRequired,
  webUrl: PropTypes.string,
  onExitCollection: PropTypes.func.isRequired,
  error: PropTypes.shape({
    status: PropTypes.number.isRequired,
    message: PropTypes.string.isRequired,
    data: PropTypes.array,
  }),
  isSearchEnabled: PropTypes.bool,
  withClickAndCollect: PropTypes.bool.isRequired,
  showFulfillmentSwitchControl: PropTypes.bool.isRequired,
  showLogisticsModal: PropTypes.bool.isRequired,
  /**
   * The currently selected fulfillment method.
   */
  selectedMethod: fulfillmentMethodType.isRequired,
  isHomeMapOpen: PropTypes.bool.isRequired,
};

HomeFeedFilters.defaultProps = {
  title: '',
  titleLink: '',
  neighborhood: '',
  dateTimeLabel: '',
  searchId: '',
  webUrl: '',
  error: undefined,
  isSearchEnabled: false,
};

export const mapStateToProps = (state) => {
  const { feed } = state.home;
  return {
    filters: feed.filters,
    sort: feed.sort,
    selectedFilters: buildSelectedFilters(state),
    defaultFilters: buildDefaultFilters(state),
    titleLink: getCollectionLink(state) || '',
    title: getTitle(state),
    searchId: getSearchId(state),
    webUrl: getUrl(state),
    loading: feed.loading,
    neighborhood: getNeighborhood(state),
    dateTimeLabel: getDateTimeLabel(state),
    error: feed.error,
    isSearchEnabled: isHomeSearchActive(state),
    withClickAndCollect: isFeatureActive(state, CO_CLICK_AND_COLLECT),
    showFulfillmentSwitchControl: getHasMultipleFulfillmentMethods(state),
    showLogisticsModal: showLogisticsModalSelector(state),
    selectedMethod: getFulfillmentMethod(state),
    isHomeMapOpen: getIsHomeMapOpen(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  toggleLogisticsModal: (isOpen) => dispatch(toggleLogisticsModalAction(isOpen)),
  trackTappedLogisticsControl: () => dispatch(trackTappedLogisticsControlAction('restaurant list')),
  showLocationSearchModal: () => dispatch(showLocationSearchModal()),
  applyFilters: debounce((selectedFilters) => dispatch(requestHomeFeed({ selectedFilters })), 350),
  trackTappedFilter: (filterData) => dispatch(trackTappedFilter(filterData)),
  trackTappedFilterOption: (options) => dispatch(trackTappedFilterOption(options)),
  trackTappedFilterIcon: () => dispatch(trackTappedFilterIcon()),
  trackToggleFilterSection: (filterSectionInfo) =>
    dispatch(trackToggleFilterSection(filterSectionInfo)),
  trackViewedMobileFilters: (filterId) => dispatch(trackViewedMobileFiltersHomeFeed(filterId)),
  onExitCollection: () => dispatch(requestHomeFeed({ clearCollection: true })),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(HomeFeedFilters);
